import { useEffect } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error no types
import getDeviceType from 'feedback-utils/getDeviceType';
import { useSubmissionUpdates } from 'feedback-public-submission-ui/hooks/useSubmissionUpdates';
import SurveyContents from 'feedback-public-submission-ui/containers/SurveyContents';
import { getFeedbackResponseSelector } from 'feedback-public-submission-ui/selectors';
import { areParamsValid } from 'feedback-public-submission-ui/utils/areParamsValid';
import { useSurveyConfig } from 'feedback-public-submission-ui/hooks/useSurveyConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const LiveSurvey = ({
  params,
  surveyType
}) => {
  const {
    fetchSurvey
  } = useSurveyConfig();
  const feedbackResponse = useSelector(getFeedbackResponseSelector);
  const device = getDeviceType(window.innerWidth);
  const {
    setSelectedRating
  } = useSubmissionUpdates();
  useEffect(() => {
    if (areParamsValid(params)) {
      setSelectedRating(params.rating);
      fetchSurvey(params, surveyType);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(SurveyContents, {
    device: device,
    feedbackResponse: feedbackResponse,
    params: params,
    surveyType: surveyType
  });
};
export default LiveSurvey;